<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
export default {
  name: "wl-article",
  props: {
    list: {
      type: Array,
      required: false,
    },
  },
  components: {},
  data() {
    return {

    };
  },
  watch: {},
  computed: {},
  mounted() {

  },
  methods: {
    jumpExpert(item){
      if(['temp','official','manager'].indexOf(item.userType)===-1){
        this.$glf.goUrl('push','/expert_info/'+item.userId);
      }

      // if(item.userType!=='temp'){
      //   this.$glf.goUrl('push','/expert_info/'+item.userId);
      // }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/wl-article/index.vue